var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('elac-login',{on:{"login":function($event){_vm.show = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }